export const componentList = [
    {
        id: 1,
        title: "Input",
    },
    {
        id: 2,
        title: "Button",
    },
    {
        id: 3,
        title: "Avatar",
    },
    {
        id: 4,
        title: "Alert",
    },
    {
        id: 5,
        title: "Badge",
    },
    {
        id: 6,
        title: "Card",
    },
    {
        id: 7,
        title: "Text",
    },
    {
        id: 8,
        title: "Image",
    },
    {
        id: 9,
        title: "List",
    },
];